import { combineReducers } from "redux";
import botReducer from "./bot-reducer";
import authReducer from "./auth-reducer";
import portfolioReducer from "./portfolio-reducer";
import dashboardReducer from "./dashboard-reducer";
import dealReducer from "./deal-reducer";
import settingReducer from "./setting-reducer";
import dataReducer from "./data-reducer";
import { RESET_PAPER_ACCOUNT, SIGN_OUT } from "../actions/types";
import storage from "redux-persist/lib/storage";
import terminalReducer from "./terminal-reducer";
import affiliateReducer from "./affiliate-reducer";
import createBotReducer from "./create-bot-reducer";
import marketplaceReducer from "./marketplace-reducer";
import createTemplateReducer from "./create-template-reducer";
import SubscriptionReducer from "./subscription-reducer";
import PriceAlertReducer from "./price-alert-reducer";
import paginationReducer from "./pagination-reducer";
import ReportReducer from "./report-reducer";
import marketIntelligenceReducer from "./market-intelligence-reducer";
import cacheReducer from "./cache-reducer";
import resetPaperAccount from "./reset-paper-account";

const appReducer = combineReducers({
  bots: botReducer,
  auth: authReducer,
  portfolio: portfolioReducer,
  dashboard: dashboardReducer,
  deals: dealReducer,
  pagination: paginationReducer,
  settings: settingReducer,
  terminal: terminalReducer,
  data: dataReducer,
  affiliate: affiliateReducer,
  createBot: createBotReducer,
  marketplace: marketplaceReducer,
  newTemplate: createTemplateReducer,
  subscription: SubscriptionReducer,
  priceAlert: PriceAlertReducer,
  report: ReportReducer,
  marketIntelligence: marketIntelligenceReducer,
  cache: cacheReducer,
});

export default (state, action) => {
  if (action.type === RESET_PAPER_ACCOUNT && state) {
    state = resetPaperAccount(state);
  }
  if (action.type == SIGN_OUT) {
    storage.removeItem("persist:root");
    state = undefined;
  }
  return appReducer(state, action);
};
